import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import DrumMachine from './Drum_Machine';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DrumMachine>
    </DrumMachine>
  </React.StrictMode>
);

